import React, { Component } from 'react'
import Slick from 'react-slick'
import PropTypes from 'prop-types'
import Nav from './Nav'

import './slick.css'
import './slider.css'

const settings = {
  arrows: false,
  dots: false,
  focusOnSelect: false,
  infinite: true,
  pauseOnHover: false,
  fade: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
}

class Slider extends Component {
  constructor (props) {
    super(props)
    this.state = {
      active: 0
    }

    this.beforeChange = this.beforeChange.bind(this)
    this.afterChange = this.afterChange.bind(this)
  }

  beforeChange (oldIndex, newIndex) {
    this.nav.onSlideChange(newIndex)
  }

  afterChange (index) {
    this.setState({ active: index })
  }

  render () {
    if (!this.props.slides && !this.props.hero) {
      return false
    }

    if (this.props.hero) {
      const index = Math.floor(Math.random() * this.props.hero.length)
      return (
        <div className='slider slider--hero'>
          <div
            className='slider__slide'
            style={{ backgroundImage: `url(${this.props.hero[index].original[0]})` }}
          />
        </div>
      )
    }

    const slides = this.props.slides.value.map((slide, idx) => (
      <div key={idx}>
        <div
          className='slider__slide'
          style={{ backgroundImage: `url(${slide.image.value.original[0]})` }}
        />
      </div>
    ))

    return (
      <div className='slider'>
        <Slick
          {...settings}
          beforeChange={this.beforeChange}
          afterChange={this.afterChange}>
          {slides}
        </Slick>
        <Nav
          ref={nav => { this.nav = nav }}
          slides={this.props.slides.value}
        />
      </div>
    )
  }
}

Slider.propTypes = {
  slides: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  hero: PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
}

export default Slider



// WEBPACK FOOTER //
// ./src/components/Slider/index.js